import { css } from 'emotion'
// import { BORDER_RADIUS } from 'constants/styleConstants'

export const footerDarkStyles = css`
  border-top: 1px solid #ccc;
  background-color: #f5f5f5;
`
